module.exports = "<div style=\"margin:auto; max-width: 1024px;\">\n  <router-outlet></router-outlet>\n</div>"